var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1173",
    "data-name": "Group 1173",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-angle-small-right",
    d: "M14.37,9.182,10.531,5.248a.822.822,0,0,0-1.179,0,.859.859,0,0,0-.183.279.877.877,0,0,0,0,.659.859.859,0,0,0,.183.279L13.2,10.391a.856.856,0,0,1,.183.279.877.877,0,0,1,0,.659.857.857,0,0,1-.183.279L9.351,15.533a.873.873,0,0,0,0,1.213.823.823,0,0,0,1.184,0l3.839-3.934a2.616,2.616,0,0,0,0-3.634Z",
    transform: "translate(-0.103 1)",
    fill: "#293240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.df505604bdd131e99815576f9ed525f4.svg";
export { ForwardRef as ReactComponent };